import client from '@/services/';

const state = () => ({
    all: [],
    one: [],
    societe: [],
    attestation: []
});

const getters = {
    all: state => state.all,
    one: state => state.one,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAllConnectee(cxt) {
        let data = await client.get('/stagiaire/all');
        cxt.commit("SET_ALL", data.data);
        return data;
    },
    async activate(cxt, stagiaireId) {
        let data = await client.get(`stagiaire/activate/${stagiaireId}`);
        return data;
    },
    async getStagiaireRapport(context, { stagiaireId, params = {} }) {
        try {
            const { page = 0, size = 10, sort = '' } = params;
            const queryParams = new URLSearchParams({ page, size, sort }).toString();
            const url = `/rapports/stagiaire/${stagiaireId}?${queryParams}`;
            console.log("URL appelée :", url);

            const response = await client.get(url);
            return response;
        } catch (error) {
            console.error("Erreur dans getStagiaireRapport :", error);
            throw error;
        }
    },

    async getStagiairePresence(context, { stagiaireId, params = {} }) {
        try {
            const { page = 0, size = 10, sort = '' } = params;
            const queryParams = new URLSearchParams({ page, size, sort }).toString();
            const url = `/rapports/stagiaire/${stagiaireId}?${queryParams}`;
            //console.log("URL appelée :", url);

            const response = await client.get(url);
            return response;
        } catch (error) {
            console.error("Erreur dans getStagiaireRapport :", error);
            throw error;
        }
    },
    async getStagiairePresence(context, { stagiaireId, params = {} }) {
        try {
            const { page = 0, size = 10, sort = '' } = params;
            const queryParams = new URLSearchParams({ page, size, sort }).toString();
            const url = `/presences/stagiaire/${stagiaireId}?${queryParams}`;
            const response = await client.get(url);
            return response;
        } catch (error) {
            console.error("Erreur dans getStagiairePresence :", error);
            throw error;
        }
    },


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
